import * as e from "react";
const r = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.862 7.037h0l4.95 4.95.004.003-.003.003-4.96 4.96h0a7 7 0 01-9.905 0s0 0 0 0l-4.94-4.959h0l-.004-.004.003-.003 4.95-4.95h0a7 7 0 019.905 0z",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement("circle", { cx: 12, cy: 12, r: 3, stroke: "#2d6ded", strokeWidth: 2 })
);
export {
  r as default
};
